import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import './Pages.css';

export const LGPD: React.FC = () => {
  return (
    <div className="ns-legal-page">
      <header className="ns-legal-header">
        <div className="ns-legal-header-content">
          <Link to="/" className="ns-legal-logo">
            <span className="mark">NS</span>
            <span className="text">NutriSync</span>
          </Link>
          <Link to="/">
            <Button variant="secondary">Voltar ao início</Button>
          </Link>
        </div>
      </header>

      <main className="ns-legal-main">
        <div className="ns-legal-container">
          <h1>Lei Geral de Proteção de Dados (LGPD)</h1>
          <p className="ns-legal-intro">
            O NutriSync está comprometido com a proteção dos dados pessoais de nossos usuários, 
            em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
          </p>

          <section className="ns-legal-section">
            <h2>1. O que é a LGPD?</h2>
            <p>
              A Lei Geral de Proteção de Dados (LGPD) é a legislação brasileira que estabelece 
              regras sobre coleta, armazenamento, tratamento e compartilhamento de dados pessoais. 
              Ela garante maior controle aos titulares sobre seus dados pessoais e impõe obrigações 
              às empresas que lidam com essas informações.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>2. Compromisso do NutriSync com a LGPD</h2>
            <p>
              O NutriSync está totalmente comprometido com o cumprimento da LGPD e adota as 
              melhores práticas de segurança e privacidade para proteger os dados de nossos usuários.
            </p>
            <ul className="ns-legal-list">
              <li>
                <strong>Transparência:</strong> Informamos claramente como coletamos, usamos e 
                protegemos seus dados pessoais.
              </li>
              <li>
                <strong>Segurança:</strong> Implementamos medidas técnicas e organizacionais 
                adequadas para proteger seus dados contra acesso não autorizado, perda ou destruição.
              </li>
              <li>
                <strong>Minimização:</strong> Coletamos apenas os dados necessários para prestar 
                nossos serviços.
              </li>
              <li>
                <strong>Finalidade:</strong> Utilizamos seus dados apenas para as finalidades 
                informadas e com seu consentimento.
              </li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>3. Dados Coletados</h2>
            <p>O NutriSync coleta os seguintes tipos de dados:</p>
            
            <h3>3.1. Dados do Nutricionista</h3>
            <ul className="ns-legal-list">
              <li>Nome completo</li>
              <li>E-mail</li>
              <li>Telefone</li>
              <li>CRN (Conselho Regional de Nutricionistas)</li>
              <li>Dados de pagamento (processados por provedores terceirizados seguros)</li>
            </ul>

            <h3>3.2. Dados dos Pacientes</h3>
            <ul className="ns-legal-list">
              <li>Nome completo</li>
              <li>Data de nascimento</li>
              <li>E-mail e telefone (quando fornecido pelo nutricionista)</li>
              <li>Informações de saúde e nutricionais</li>
              <li>Medidas corporais</li>
              <li>Histórico de consultas e planos alimentares</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>4. Finalidade do Tratamento</h2>
            <p>Utilizamos seus dados pessoais para:</p>
            <ul className="ns-legal-list">
              <li>Prestar os serviços da plataforma NutriSync</li>
              <li>Gerenciar contas de usuários e autenticação</li>
              <li>Processar pagamentos e assinaturas</li>
              <li>Enviar notificações e comunicações relacionadas ao serviço</li>
              <li>Melhorar nossos serviços e experiência do usuário</li>
              <li>Cumprir obrigações legais e regulatórias</li>
              <li>Prevenir fraudes e garantir a segurança da plataforma</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>5. Base Legal</h2>
            <p>O tratamento de dados pessoais pelo NutriSync é baseado em:</p>
            <ul className="ns-legal-list">
              <li>
                <strong>Consentimento:</strong> Quando você nos fornece dados e aceita nossos 
                termos de uso e política de privacidade.
              </li>
              <li>
                <strong>Execução de contrato:</strong> Para cumprir as obrigações do serviço 
                contratado.
              </li>
              <li>
                <strong>Legítimo interesse:</strong> Para melhorar nossos serviços e garantir 
                a segurança da plataforma.
              </li>
              <li>
                <strong>Cumprimento de obrigação legal:</strong> Quando necessário para atender 
                exigências legais e regulatórias.
              </li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>6. Compartilhamento de Dados</h2>
            <p>
              O NutriSync não vende seus dados pessoais. Podemos compartilhar informações apenas nas 
              seguintes situações:
            </p>
            <ul className="ns-legal-list">
              <li>
                <strong>Prestadores de serviços:</strong> Com empresas que nos auxiliam na operação 
                da plataforma (hospedagem, processamento de pagamentos), sempre sob contratos 
                que garantem a proteção dos dados.
              </li>
              <li>
                <strong>Obrigações legais:</strong> Quando exigido por lei, ordem judicial ou 
                autoridades competentes.
              </li>
              <li>
                <strong>Com seu consentimento:</strong> Em outras situações, apenas com sua 
                autorização explícita.
              </li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>7. Seus Direitos sob a LGPD</h2>
            <p>Como titular de dados pessoais, você tem os seguintes direitos:</p>
            
            <div className="ns-rights-grid">
              <div className="ns-right-card">
                <div className="ns-right-icon">🔍</div>
                <h3>Confirmação e Acesso</h3>
                <p>Confirmar a existência de tratamento e acessar seus dados pessoais.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">✏️</div>
                <h3>Correção</h3>
                <p>Solicitar a correção de dados incompletos, inexatos ou desatualizados.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">🗑️</div>
                <h3>Eliminação</h3>
                <p>Solicitar a eliminação de dados desnecessários ou tratados em desconformidade.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">📋</div>
                <h3>Portabilidade</h3>
                <p>Solicitar a portabilidade de seus dados para outro fornecedor de serviço.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">🚫</div>
                <h3>Revogação do Consentimento</h3>
                <p>Revogar seu consentimento a qualquer momento.</p>
              </div>
              
              <div className="ns-right-card">
                <div className="ns-right-icon">ℹ️</div>
                <h3>Informação</h3>
                <p>Obter informações sobre entidades públicas e privadas com as quais compartilhamos dados.</p>
              </div>
            </div>
          </section>

          <section className="ns-legal-section">
            <h2>8. Como Exercer Seus Direitos</h2>
            <p>
              Para exercer qualquer um dos direitos mencionados acima, entre em contato conosco através de:
            </p>
            <ul className="ns-legal-list">
              <li><strong>E-mail:</strong> privacidade@nutrisync.com.br</li>
              <li><strong>Formulário:</strong> Através da área de configurações da sua conta</li>
            </ul>
            <p>
              Responderemos sua solicitação no prazo de até 15 (quinze) dias, conforme estabelecido 
              pela LGPD.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>9. Medidas de Segurança</h2>
            <p>O NutriSync adota as seguintes medidas de segurança:</p>
            <ul className="ns-legal-list">
              <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
              <li>Criptografia de dados sensíveis em repouso</li>
              <li>Controle de acesso baseado em permissões</li>
              <li>Monitoramento contínuo de segurança</li>
              <li>Backups regulares e seguros</li>
              <li>Treinamento da equipe em segurança da informação</li>
              <li>Auditorias periódicas de segurança</li>
            </ul>
          </section>

          <section className="ns-legal-section">
            <h2>10. Retenção de Dados</h2>
            <p>
              Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades 
              para as quais foram coletados, ou conforme exigido por lei. Quando os dados não forem 
              mais necessários, serão eliminados de forma segura.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>11. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o 
              uso da plataforma e personalizar conteúdo. Você pode gerenciar suas preferências de 
              cookies através das configurações do seu navegador.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>12. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta política de conformidade com a LGPD periodicamente. 
              Notificaremos sobre mudanças significativas através de e-mail ou aviso na plataforma. 
              Recomendamos revisar esta página regularmente.
            </p>
          </section>

          <section className="ns-legal-section">
            <h2>13. Encarregado de Proteção de Dados (DPO)</h2>
            <p>
              O NutriSync possui um Encarregado de Proteção de Dados (DPO) responsável por receber 
              comunicações dos titulares e da Autoridade Nacional de Proteção de Dados (ANPD).
            </p>
            <div className="ns-dpo-contact">
              <p><strong>Contato do DPO:</strong></p>
              <p>E-mail: dpo@nutrisync.com.br</p>
            </div>
          </section>

          <section className="ns-legal-section">
            <h2>14. Contato</h2>
            <p>
              Para questões relacionadas à proteção de dados e LGPD, entre em contato:
            </p>
            <div className="ns-contact-info">
              <p><strong>NutriSync</strong></p>
              <p>E-mail: privacidade@nutrisync.com.br</p>
              <p>Telefone: (11) 0000-0000</p>
            </div>
          </section>

          <div className="ns-legal-footer-actions">
            <Link to="/">
              <Button>Voltar ao início</Button>
            </Link>
            <Link to="/privacidade">
              <Button variant="secondary">Ver Política de Privacidade</Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

